import map from 'lodash/map';

import { Speed } from '@r1-frontend/api-domru/api-tariffs/v1/tariff/calculate/dto/ResponseDto';

const prepareSpeed = (incoming: Speed[], isTvSelected: boolean) => {
    return map(incoming, (speed, key) => {
        return {
            id: Number(key),
            speed: speed.speed,
            price: Number(speed.cost || 0),
            alias: speed.alias || speed.speed,
            title: speed.title || speed.speed,
            descriptionList: speed.advantages[isTvSelected ? 'bundle' : 'mono'],
        };
    });
};

export default prepareSpeed;
